import styled from "@emotion/styled";
import BasicButton from "@components/button/BasicButton";
import Image from "@components/item/Image";
import { useTheme } from "@emotion/react";
import { useTranslation } from "react-i18next";

const Container = styled.div({
  display: "flex",
  flexDirection: "column",
  justifyContent: "space-between",
  position: "relative",
  height: "calc(100vh - 6rem)",
});

const ButtonWrapper = styled.div({
  position: "absolute",
  bottom: "0",
  left: "0",
  width: "100%",
});

const ContentWrapper = styled.div({
  display: "flex",
  flexDirection: "column",
  justifyContent: "space-around",
  alignItems: "center",
  marginTop: "22.8rem",
});

const Message = styled.p(({ theme }) => ({
  fontSize: "2.4rem",
  marginTop: "4rem",
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  textAlign: "center",
  fontWeight: theme.fontWeight.medium,
}));

interface SuccessMessageProps {
  message: string;
  buttonText: string;
  onButtonClick: () => void;
}

const SuccessMessage: React.FC<SuccessMessageProps> = ({
  message,
  buttonText,
  onButtonClick,
}) => {
  const theme = useTheme();
  const { t } = useTranslation();
  return (
    <Container>
      <ContentWrapper>
        <Image
          src={theme.image.check_circle.default}
          height="6rem"
          width="6rem"
        />

        <Message>{t(message)}</Message>
      </ContentWrapper>

      <ButtonWrapper>
        <BasicButton
          title={buttonText}
          onClick={onButtonClick}
          width="100%"
          height="5.2rem"
        />
      </ButtonWrapper>
    </Container>
  );
};

export default SuccessMessage;
